import PartnerPage from "@/views/partner/PartnerPage.vue";

import Profile from "@/views/partner/children/profile/Profile.vue";
import Dashboard from "@/views/partner/children/dashboard/Dashboard.vue";
import PartnerFinance from "@/views/partner/children/finance/Finance.vue";
import PartnerClasses from "@/views/partner/children/classes/PartnerClasses.vue";
import PartnerClassesForm from "@/views/partner/children/classes/form/PartnerClassesForm.vue";
import CourseIndex from "@/views/partner/children/course/CourseIndex.vue";
import Course from "@/views/partner/children/course/Course.vue";
import CourseContent from "@/views/partner/children/course/CourseContent.vue";
import Calendar from "@/views/partner/children/calendar/Calendar.vue";
import NotificationsArea from "@/views/partner/children/notifications/NotificationsArea.vue";

const prefix = "/connect/professor";

export const partner_routes = [
  {
    path: prefix,
    name: "Bem-vindo",
    component: PartnerPage,
    meta: { authRequired: true, preventAuth: true },
    children: [
      {
        path: `${prefix}/cockpit`,
        name: "Meu progresso",
        component: Dashboard,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/perfil`,
        name: "Perfil",
        component: Profile,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/turmas`,
        name: "Turmas",
        meta: { authRequired: true, preventAuth: true },
        component: PartnerClasses,
      },
      {
        path: `${prefix}/turmas/:id`,
        name: "Detalhe da turma",
        component: PartnerClassesForm,
        meta: { authRequired: true, preventAuth: true },
      },
      {
        path: `${prefix}/curso`,
        name: "Curso",
        meta: { authRequired: true, preventAuth: true },
        component: CourseIndex,
      },
      {
        path: `${prefix}/curso/material/:id`,
        name: "Conteúdo da aula",
        meta: { authRequired: true, preventAuth: true },
        component: CourseContent,
      },
      {
        path: `${prefix}/curso/:id`,
        name: "Aulas do módulo",
        meta: { authRequired: true, preventAuth: true },
        component: Course,
      },
      {
        path: `${prefix}/curso/:module/:id`,
        name: "Material",
        meta: { authRequired: true, preventAuth: true },
        component: CourseContent,
      },
      {
        path: `${prefix}/notificacoes`,
        name: "Notificacoes",
        meta: { authRequired: true, preventAuth: true },
        component: NotificationsArea,
      },
      {
        path: `${prefix}/agenda`,
        name: "Agenda",
        meta: { authRequired: true, preventAuth: true },
        component: Calendar,
      },
      {
        path: `${prefix}/financeiro`,
        name: "Financeiro",
        meta: { authRequired: true, preventAuth: true },
        component: PartnerFinance,
      },
    ],
  },
];
